(function ($, window, undefined) {
	'use strict';

	(function () {

		if ($('.tabs-container').length > 0) {
			/*
			 * Ajusta a altura inicial da primeira aba aberta
			 */
			/*setTimeout(function () {
				$('.tabs-container').css({
					'height': $('.tab-pane.active').height()
				});
			});*/

			//$('.content-nav-link').on('click', function (event) {
			//	event.preventDefault();

			//	/* 
			//	 * Adiciona a classe ativo no menu de navegacao das abas
			//	 */
			//	$('.content-nav-link').removeClass('active');
			//	$(this).addClass('active');

			//	/*
			//	 * Adiciona a class active no conteudo da aba atual
			//	 */
			//	var $elem = $(this).attr('href');
			//	$('.tab-pane').removeClass('active');
			//	$($elem).addClass('active');

			//	/*
			//	 * Calcula a altura da aba e coloca no container
			//	 */
			//	$('.tabs-container').css({
			//		'height': $($elem).height()
			//	});
			//});
		}

	})();

})(jQuery);